var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticStyle:{"margin":"10px !important"}},[_vm._v(_vm._s(_vm.STOKADI))])])
}
var staticRenderFns = []

export { render, staticRenderFns }